module.exports = __webpack_public_path__ + "img/speaker_photo_arrow.2e9971b2.svg";